import React from 'react';
import GeneralCard from '../../../../components/card/general-card';
import { getDateTimeFormatString } from '../../../../components/common/common-helper';
import { CALENDAR_03, CAR_ICON, COPY_TO_CLIPBOARD, EMAIL, PROFILE } from '../../../../shared/AppImages';
import { convertFoxApiDateToStr } from '../../fox-reservation/fox-res-helper';

function RentalInformation(props) {
    const { rentalData, step } = props;
    return (
        <div className='flex-column row-gap-1 rental-info'>
            <h2>Rental Information</h2>
            <div className='flex-column row-gap-1'>
                <GeneralCard
                    title="Customer"
                    value={rentalData?.firstName + " " + rentalData?.lastName}
                    apiData={{
                        mainIcon: {
                            imgSrc: PROFILE,
                            mainClass: "static-icon"
                        },
                        isCopyToClipBoard: true,
                        clipBoardIcon: COPY_TO_CLIPBOARD,
                    }}
                />
                <GeneralCard
                    title="Email"
                    value={rentalData?.email}
                    apiData={{
                        mainIcon: {
                            imgSrc: EMAIL,
                            mainClass: "static-icon"
                        },
                        isCopyToClipBoard: true,
                        clipBoardIcon: COPY_TO_CLIPBOARD
                    }}
                />
                <GeneralCard
                    title="Rental Number"
                    value={rentalData?.rentalAgreementNum}
                    apiData={{
                        mainIcon: {
                            imgSrc: CAR_ICON,
                            mainClass: "static-icon"
                        },
                        isCopyToClipBoard: true,
                        clipBoardIcon: COPY_TO_CLIPBOARD
                    }}
                />
                <GeneralCard
                    title={step === 3 ? "New Return Date & Time" : "Return Date & Time"}
                    value={convertFoxApiDateToStr(rentalData?.returnDate, getDateTimeFormatString(true, false, true))}
                    apiData={{
                        mainIcon: {
                            imgSrc: CALENDAR_03,
                            mainClass: "static-icon"
                        },
                        isCopyToClipBoard: true,
                        clipBoardIcon: COPY_TO_CLIPBOARD
                    }}
                />
                {step === 3 &&
                    <>
                        <GeneralCard
                            title="Previus Return Date & Time"
                            value={convertFoxApiDateToStr(rentalData?.previousReturnDate, getDateTimeFormatString(true, false, true))}
                            apiData={{
                                mainIcon: {
                                    imgSrc: CALENDAR_03,
                                    mainClass: "static-icon"
                                },
                                isCopyToClipBoard: true,
                                clipBoardIcon: COPY_TO_CLIPBOARD
                            }}
                        />
                    </>
                }
            </div>
        </div>
    )
}

export default RentalInformation